import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { Box, Button, createTheme } from "@mui/material";
import React, { useState } from "react";
import { useQueryClient } from "react-query";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { BANKLIST } from "../../config/cacheKey";
import { BankResponse, IbanFilter } from "../../models/iban.model";
import ChipCmp from "../chip/chipCmp";
import AutocomplateCheckbox from "../dropdown/AutocomplateCheckbox";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";

const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
interface Props {
  setFilterObject: (filterObj: IbanFilter) => void;
  filterObject: IbanFilter;
  setCurrentPaginationInfo: (page: any) => void;
}

const IbanListFilters = ({
  filterObject,
  setFilterObject,
  setCurrentPaginationInfo,
}: Props) => {
  const [valueBanksOptions, setValueBanksOptions] = useState<number[]>([]);

  const [formData, setFormData] = useState<IbanFilter>();

  const queryClient = useQueryClient();
  const [valueSBanks, setValueBanks] = useState<any[]>([]);
  const banks = queryClient.getQueryData<BankResponse[]>(BANKLIST) || [];
  // const updatedBanks: GetEnumsResponse[] = banks.map((bank) => ({
  //   id: Number(bank.id),
  //   title: bank.title,
  //   enumName: undefined,
  //   enumType: "SaleStatus",
  // }));

  function changeValueBanksOptions(e: any, value: any) {
    setValueBanksOptions(value.map((item: any) => item.title));
    setValueBanks([...value]);
    const filters = queryClient.getQueryData<IbanFilter>("IbanFilter");
    queryClient.setQueryData<IbanFilter>("IbanFilter", {
      ...filters!,
      bankIds: [...e],
    });
  }

  const handleChangeForm = (event: any) => {
    setFormData({
      ...formData!,
      [event.target.id]: event.target.value,
    });
    queryClient.setQueryData<IbanFilter>("IbanFilter", {
      ...formData!,
      [event.target.id]: event.target.value,
    });
  };

  const deleteChip = () => {
    let tableFilter = queryClient.getQueryData<IbanFilter>("IbanFilter");
    tableFilter = {
      iban: "",
      owner: "",
      bankIds: [],
    };
    setFormData({
      ...formData,
      iban: "",
      owner: "",
      bankIds: [],
    });
    queryClient.setQueryData<IbanFilter>("IbanFilter", tableFilter);
    setFilterObject({});
    setValueBanks([]);
    setValueBanksOptions([]);
  };

  const handleFormSubmit = () => {
    let tableFilter = queryClient.getQueryData<IbanFilter>("IbanFilter");
    setCurrentPaginationInfo({
      pageNumber: 1,
      pageSize: 10,
    });
    setFilterObject(tableFilter!);
  };
  const setChildAccountHolderName = () => {
    let tableFilter = queryClient.getQueryData<IbanFilter>("IbanFilter");
    tableFilter = { ...tableFilter!, owner: undefined };
    setFormData({ ...formData, owner: "" });
    queryClient.setQueryData<IbanFilter>("IbanFilter", tableFilter!);
    setFilterObject(tableFilter!);
  };
  const setChildiban = () => {
    let tableFilter = queryClient.getQueryData<IbanFilter>("IbanFilter");
    tableFilter = { ...tableFilter!, iban: undefined };
    setFormData({ ...formData, iban: "" });
    queryClient.setQueryData<IbanFilter>("IbanFilter", tableFilter!);
    setFilterObject(tableFilter!);
  };
  const setChildBanks = (chip: any) => {
    const selectedItem = valueSBanks.filter((item: any) => item.title !== chip);
    setValueBanks(selectedItem);
    const reamaningItems = valueBanksOptions.filter(
      (item: any) => item !== chip,
    );
    setValueBanksOptions(reamaningItems.map((item: any) => item));
    const tabelFilter = queryClient.getQueryData<IbanFilter>("IbanFilter");
    if (tabelFilter !== undefined && tabelFilter != null) {
      tabelFilter!.bankIds = tabelFilter!.bankIds
        ?.filter((item: any) => item.title !== chip)
        .map((items: any) => {
          return items;
        });
    }
    setFilterObject({
      ...filterObject,
      bankIds: selectedItem.map((item) => item.id),
    });
  };
  return (
    <div>
      <Box>
        <div className="row">
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"نام صاحب حساب"}
              label={"نام صاحب حساب"}
              required={false}
              value={formData?.owner}
              onChange={(e: any) => handleChangeForm(e)}
              name="owner"
              id="owner"
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
            style={{ marginTop: "1vh" }}
          >
            <MaterialTextFieldComponent
              helperText={""}
              placeHolder={"شماره شبا"}
              label={"شماره شبا"}
              required={false}
              value={formData?.iban}
              onChange={(e: any) => handleChangeForm(e)}
              name="iban"
              id="iban"
            />
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 dropdownCmp2-container"
            style={{ marginTop: "1vh" }}
          >
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                {banks && (
                  <div dir="rtl">
                    <AutocomplateCheckbox
                      id="banks"
                      name="banks"
                      value={valueBanksOptions}
                      label={"بانک"}
                      options={banks}
                      onChange={changeValueBanksOptions}
                      changeMultiSelect={changeValueBanksOptions}
                      responseValue={valueSBanks}
                    />
                  </div>
                )}
              </ThemeProvider>
            </CacheProvider>
          </div>
          <div
            className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
            style={{ marginTop: "1vh" }}
          >
            <Button
              fullWidth
              variant="contained"
              // type="submit"
              className="btnForm SuccessDefault  "
              onClick={handleFormSubmit}
            >
              اعمال فیلتر
            </Button>
          </div>
        </div>
        {(formData?.owner || formData?.iban || valueSBanks.length > 0) && (
          <div
            style={{ display: "flex", alignItems: "center" }}
            className="row tableCMP"
          >
            <Button
              onClick={deleteChip}
              style={{
                justifyContent: "right",
                minWidth: "25px",
                marginRight: "-1vh",
                marginTop: "1vh",
              }}
            >
              <img
                style={{ height: "24px", width: "24px" }}
                src="images/RemoveAllFilters.svg"
                alt=""
              />
            </Button>
            <ChipCmp
              item={formData?.owner}
              enamValue={formData?.owner}
              index={formData?.owner?.length}
              setChildValue={setChildAccountHolderName}
            />
            <ChipCmp
              item={formData?.iban}
              enamValue={formData?.iban}
              index={formData?.iban?.length}
              setChildValue={setChildiban}
            />
            {valueBanksOptions.map((title, index) => (
              <ChipCmp
                item={title}
                enamValue={title}
                index={index}
                setChildValue={setChildBanks}
              />
            ))}
          </div>
        )}
      </Box>
    </div>
  );
};

export default IbanListFilters;
